var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"autoflex",style:(_vm.containerStyle)},[_vm._l((_vm.slotsNames),function(slotName,index){return [_c('div',{key:index,staticClass:"autoflex__slot-container",style:(_vm.slotStyle(slotName, index === 0))},[_vm._t(slotName,null,{"done":_vm.isDoneListened(slotName) && _vm.callDone})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }